import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { TransactionRecordCategoryEnum } from '../enums/transaction-record-category.enum';
import { TransactionStatusEnum } from '../enums/transaction-status.enum';
import { TransactionTypeEnum } from '../enums/transaction-type.enum';

/**
 * Transactions filters
 */
export class TransactionsFilters extends ApiRequestFilters {
	/**
	 * Vehicles id values
	 */
	vehicles?: number[];

	/**
	 * Rental Agreements id values
	 */
	rentalAgreements?: number[];

	/**
	 * Rental Reservations id values
	 */
	rentalReservations?: number[];

	/**
	 * Vehicle Insurances id values
	 */
	vehicleInsurances?: number[];

	/**
	 * Vehicle Maintenances id values
	 */
	vehicleMaintenances?: number[];

	/**
	 * Vehicle Road taxes id values
	 */
	vehicleRoadTaxes?: number[];

	/**
	 * Vehicle Road Worthy Checks id values
	 */
	vehicleRoadWorthyChecks?: number[];

	/**
	 * Locations id values
	 */
	locations?: number[];

	/**
	 * Customers id values
	 */
	customers?: number[];

	/**
	 * Suppliers id values
	 */
	suppliers?: number[];

	/**
	 * Agents id values
	 */
	agents?: number[];

	/**
	 * Amount from
	 */
	@TransformFloat()
	amountFrom?: number;

	/**
	 * Amount to
	 */
	@TransformFloat()
	amountTo?: number;

	/**
	 * Status values
	 */
	statuses?: TransactionStatusEnum[];

	/**
	 * Type values
	 */
	types?: TransactionTypeEnum[];

	/**
	 * Record category enum values
	 */
	recordCategories?: TransactionRecordCategoryEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];

	/**
	 * External reference (e.g. reservation request UUID or payment transaction reference)
	 */
	externalReference?: string;
}
